// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"84":"8c1f988e1fa0ede2","321":"06315b9f6114a87a","495":"06315b9f6114a87a","552":"f1d1f37345f5ed16"}[chunkId] + ".css";
};